import { createFileRoute } from "@tanstack/react-router";
import { ZeroFeeDirectoryLaunch } from "@/components/press/articles/ZeroFeeDirectoryLaunch";

const SITE = "https://heallexa.com";
const URL = `${SITE}/press/zero-fee-ai-directory-launch`;
const TITLE =
  "Heallexa Launches World's Largest AI Healthcare Directory with 6.3 Million Records, Eliminating Per-Appointment Booking Fees for Providers";
const DESCRIPTION =
  "Heallexa launches the world's largest AI healthcare directory with 6.3 million provider records and zero per-appointment booking fees, powered by WhatsApp, SMS, and voice AI agents.";
const DATE_ISO = "2026-06-08";

export const Route = createFileRoute("/press/zero-fee-ai-directory-launch")({
  head: () => ({
    meta: [
      { title: `${TITLE} | Heallexa` },
      { name: "description", content: DESCRIPTION },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESCRIPTION },
      { property: "og:url", content: URL },
      { property: "og:type", content: "article" },
      { property: "article:published_time", content: DATE_ISO },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: TITLE },
      { name: "twitter:description", content: DESCRIPTION },
    ],
    links: [{ rel: "canonical", href: URL }],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "NewsArticle",
          headline: TITLE,
          description: DESCRIPTION,
          datePublished: DATE_ISO,
          dateModified: DATE_ISO,
          url: URL,
          author: { "@type": "Organization", name: "Heallexa", url: SITE },
          publisher: {
            "@type": "Organization",
            name: "Heallexa",
            logo: { "@type": "ImageObject", url: `${SITE}/logo.png` },
          },
          mainEntityOfPage: { "@type": "WebPage", "@id": URL },
        }),
      },
    ],
  }),
  component: ZeroFeeDirectoryLaunch,
});
